// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar-hour[data-v-cb8c8924] {\n  background-color: #D9E5DF;\n  border: solid 1px #aab7b1;\n}\n.columna-fija[data-v-cb8c8924] {\n  position: sticky;\n  left: 0;\n  min-width: 100px;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  margin: 0;\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
